// Isotipo "user premium" — sigue tokens Troly exactos
// Brass (#C8A55B) = señal premium oficial; Mist (#F2EFE9) = figura sobre oscuro
const BRASS      = '#C8A55B';
const BRASS_DARK = '#8a6a2a';
const MIST       = '#F2EFE9';
const GRAD_ID    = 'tprem';

export default function PremiumBadge({ size = 28 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Troly Premium"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      {/* Shield */}
      <path
        d="M14 2L4 6v8c0 5.5 4.3 10.7 10 12 5.7-1.3 10-6.5 10-12V6L14 2Z"
        fill={`url(#${GRAD_ID})`}
      />
      {/* Checkmark */}
      <path
        d="M9 15.5l3.5 3.5 6.5-7"
        stroke={MIST}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id={GRAD_ID} x1="14" y1="2" x2="14" y2="26" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor={BRASS} />
          <stop offset="100%" stopColor={BRASS_DARK} />
        </linearGradient>
      </defs>
    </svg>
  );
}
